import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";
import S3FileUpload from "react-s3";

function TalkToUs(props) {
  const [items, setItems] = useState([
    {
      image: "",
      title: "",
      description: "",
      cta_title: "",
      cta_link: "",
    },
  ]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("user", user);

  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "talktous",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  //handleItemImage
  const handleItemImage = (event, index) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        const newItem = [...items];
        newItem[index][
          "image"
        ] = `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`;
        setItems(newItem);
      })
      .catch((err) => console.log(err));
  };

  // remove item image
  const removeItemImage = (index) => {
    const newItem = [...items];
    newItem[index]["image"] = "";
    setItems(newItem);
  };

  // get items
  const getTalkToExpert = () => {
    setIsLoading(true);
    apiReq(url.GET_TALK_TO_US, {}, "get", null)
      .then((res) => {
        console.log("items>>>", res);
        if (res.success && res.data !== null) {
          setItems(res.data.items);
          setValue("title", res.data.title);
          setValue("popup_title", res.data.popup_title);
          setValue("popup_description", res.data.popup_description);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getTalkToExpert();
  }, []);

  // Todo: Create faq first time
  const createTalkToExpert = (data) => {
    if (isEmpty) {
      if (items[0].question === "" || items[0].answer === "") {
        Swal.fire({
          title: "Error",
          text: "Please fill the question and answer",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        setIsLoading(true);
        apiReq(
          url.CREATE_TALK_TO_US,
          {
            title: data.title,
            items: items,
            popup_title: data.popup_title,
            popup_description: data.popup_description,
            meta_title: data.meta_title,
            meta_description: data.meta_description,
          },
          "post",
          {
            Authorization: `Bearer ${user.user?.token}`,
          }
        )
          .then((res) => {
            setIsEmpty(false);
            setIsLoading(false);
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            // console.log("res>>>", res);
          })
          .catch((err) => {
            setIsLoading(false);
            console.log("err>>>", err);
          });
      }
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_TALK_TO_US,
        {
          title: data.title,
          items: items,
          popup_title: data.popup_title,
          popup_description: data.popup_description,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // Todo: Update Faq

  //Todo: addNewFaq
  const addNewFaq = () => {
    setItems([
      ...items,
      { image: "", title: "", description: "", cta_title: "", cta_link: "" },
    ]);
  };

  // Todo: removeFaq
  const removeFaq = (index) => {
    const newitems = [...items];
    newitems.splice(index, 1);
    setItems(newitems);
  };

  // Todo: handleCardChange
  const handleCardChange = (e, index) => {
    const { name, value } = e.target;
    const newitems = [...items];
    newitems[index][name] = value;
    setItems(newitems);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {allFields?.title !== "" ? allFields?.title : "Talk To Us Page"}
              </h5>
              <hr />
              <form onSubmit={handleSubmit(createTalkToExpert)}>
                <div className="mt-4">
                  <div className="mb-3">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("title", { required: true })}
                      placeholder="Enter page title"
                    />
                    {errors.title && (
                      <span className="text-danger">Title is required</span>
                    )}
                  </div>
                  <div className="mt-3">
                    <label>Items</label>
                    <hr />
                    {items.length > 0 && (
                      <div>
                        {items.map((item, index) => {
                          return (
                            <div key={index}>
                              <div className="row mb-4">
                                <div className="col-md-2">
                                  <div className="image_wrap">
                                    <div
                                      className="dropzone p-2 mb-0"
                                      style={{ minHeight: "auto" }}
                                    >
                                      {!item.image ? (
                                        <div className="needsclick">
                                          <div className="mb-3">
                                            <i className="ri-image-line display-4 text-muted"></i>
                                          </div>
                                          <h5 className="opacity-40">
                                            Icon image
                                          </h5>
                                          <small className="text-muted mb-0 text-center">
                                            <strong>(100X100)</strong>
                                          </small>
                                          <input
                                            type="file"
                                            className="image_upload_input"
                                            onChange={(e) =>
                                              handleItemImage(e, index)
                                            }
                                          />
                                        </div>
                                      ) : (
                                        <div className="filled_image">
                                          <img
                                            src={item.image}
                                            alt={item.title}
                                            className="img-fluid"
                                          />
                                          <div
                                            className="remove_image"
                                            onClick={() =>
                                              removeItemImage(index)
                                            }
                                          >
                                            <i className="mdi mdi-close-thick"></i>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-9">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="mb-2">
                                        <input
                                          type="text"
                                          placeholder="Title"
                                          className="form-control"
                                          value={item.title}
                                          name="title"
                                          onChange={(e) =>
                                            handleCardChange(e, index)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="mb-2">
                                        <input
                                          type="text"
                                          placeholder="Description"
                                          className="form-control"
                                          value={item.description}
                                          name="description"
                                          onChange={(e) =>
                                            handleCardChange(e, index)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="mb-2">
                                        <input
                                          type="text"
                                          placeholder="CTA Title"
                                          className="form-control"
                                          value={item.cta_title}
                                          name="cta_title"
                                          onChange={(e) =>
                                            handleCardChange(e, index)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="mb-2">
                                        <input
                                          type="text"
                                          placeholder="CTA Link"
                                          className="form-control"
                                          value={item.cta_link}
                                          name="cta_link"
                                          onChange={(e) =>
                                            handleCardChange(e, index)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-1">
                                  <button
                                    className="btn btn-danger"
                                    style={{ width: "100%" }}
                                    type="button"
                                    onClick={() => removeFaq(index)}
                                  >
                                    <i className="ri-delete-bin-line"></i>
                                  </button>
                                </div>
                              </div>
                              <hr />
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <hr />
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-success"
                        onClick={addNewFaq}
                        type="button"
                      >
                        <i className="ri-add-fill"></i> Add new section
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <h5 className="mt-4">Pop Up Content</h5>
                <hr />
                <div className="mb-3">
                  <label>Pop Up Heading</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("popup_title", { required: false })}
                    placeholder="Enter popup heading"
                  />
                </div>
                <div className="mb-3">
                  <label>Pop Up Description</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("popup_description", { required: false })}
                    placeholder="Enter popup description"
                  />
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default TalkToUs;
